// Auto-generated by scripts/generate-build-info.js during `npm run build`.
// Do not edit by hand - changes will be overwritten on the next build.
export const BUILD_TIME = "2026-09-23T06:35:46.590Z"
export const BUILD_COMMIT = "57f3b79"
